<template>
    <div class="block zbfjj" id="zbfjj">
        <div class="itemTitBox wow animated bounceInRight">
            <p class="big">主办方简介</p>
            <p class="small">SOPONSOR PROFILE</p>
        </div>
        <div class="dhxq wow animated bounceInLeft">
            <div class="dhxqItem wow animated fadeInUp">
                <!-- <div class="triangle_icon">
                    <img src="../assets/images/triangle_icon.png" alt="" />
                </div> -->
                <div class="dhxqTxt">{{ dataJson.sponsor_synopsis }}</div>
            </div>
        </div>
        <img class="bgImg" src="../assets/images/788x478.png" />
    </div>
</template>
<script>
import dataJson from "../assets/index.json";
export default {
    data() {
        return {
            dataJson,
        };
    },
};
</script>
<style lang="less" scoped>
@import url("../views/index.less");
#zbfjj {
    position: relative;
    .bgImg {
      width: 788px;
        height: 478px;
        position: absolute;
        right: 0;
        bottom: -159px;
    }
    .dhxq {
        position: relative;
        z-index: 2;
        box-sizing: border-box;
        padding: 0 35px;
        margin: 0 auto;
        margin-top: 27px;
        width: 779px;
        // height: 439px;
        background: url("../assets/images/1558x877.png") no-repeat;
        background-size: 100% 100%;
        .dhxqItem {
            display: flex;
            width: 100%;
            transition: all 0.6s;
            .triangle_icon {
                margin-top: 28px;
                width: 11px;
                height: 15px;
                margin-right: 5px;
                > img {
                    width: 100%;
                    height: 100%;
                }
            }
            .dhxqTxt {
                width: calc(100% - 16px);
                box-sizing: border-box;
                margin-left: 5px;
                padding:52px 0px 72px 0px;
                border-bottom: 1px solid #00fffc;
                font-size: 15px;
                font-family: MicrosoftYaHei;
                font-weight: 400;
                color: #ffffff;
                line-height: 1.5;
            }
            &:last-child {
                .dhxqTxt {
                    border-bottom: none;
                }
            }
            &:hover {
                transform: scale(1.05);
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/zbfjj.vue